module.exports = __webpack_public_path__ + "static/img/case-dd-page-bg-10.6d2d7ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/dd/case-dd-page-bg-10.jpg
// module id = 8Gg3
// module chunks = 1